import React from 'react';
import { Building2, Users, Heart } from 'lucide-react';

const Benefits = () => {
  const beneficiaries = [
    {
      icon: Building2,
      title: 'Bagi Kampus',
      benefits: [
        'Informasi resmi terkontrol dan konsisten',
        'Beban komunikasi panitia berkurang',
        'Citra institusi lebih profesional dan modern'
      ],
      color: 'sage'
    },
    {
      icon: Users,
      title: 'Bagi Panitia & EO',
      benefits: [
        'Koordinasi lapangan lebih rapi',
        'Risiko miskomunikasi menurun',
        'Fokus pada kelancaran prosesi akademik'
      ],
      color: 'terracotta'
    },
    {
      icon: Heart,
      title: 'Bagi Peserta Wisuda',
      benefits: [
        'Informasi mudah diakses',
        'Pengalaman wisuda lebih nyaman',
        'Kenangan bersama tersimpan rapi'
      ],
      color: 'sage'
    }
  ];

  return (
    <section id="manfaat" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Manfaat untuk Semua Pihak
          </h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {beneficiaries.map((beneficiary, index) => (
            <div 
              key={index}
              className="group p-8 bg-gradient-to-br from-cream-50 to-white rounded-2xl border-2 border-cream-200 hover:border-sage-300 transition-all duration-300 hover:shadow-lg"
            >
              <div className={`inline-flex p-4 rounded-xl mb-6 ${
                beneficiary.color === 'sage' ? 'bg-sage-100' : 'bg-terracotta-100'
              }`}>
                <beneficiary.icon className={`w-8 h-8 ${
                  beneficiary.color === 'sage' ? 'text-sage-600' : 'text-terracotta-600'
                }`} />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                {beneficiary.title}
              </h3>
              
              <ul className="space-y-4">
                {beneficiary.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <svg className="w-5 h-5 text-sage-600 mt-1 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-700 leading-relaxed">{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
